// extracted by mini-css-extract-plugin
export default {"header":"Header_header__8NwGk","inner":"Header_inner__TzgpQ","badge":"Header_badge__JJph7","title":"Header_title__iWdqE","subtitle":"Header_subtitle__yRgIR"};